import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';
import { extend } from 'flarum/common/extend';

/** The events' notifications (Events.php): a moderator's "waiting for approval", a poster's "approved". */
class EventPendingNotification extends Notification {
  icon() {
    return 'far fa-calendar';
  }
  href() {
    return '/events';
  }
  content() {
    const user = this.attrs.notification.fromUser();
    return (user ? user.displayName() : 'A member') + ' posted an event: it is waiting for approval';
  }
  excerpt() {
    return (this.attrs.notification.content() || {}).title || '';
  }
}
class EventReviewedNotification extends Notification {
  icon() {
    return (this.attrs.notification.content() || {}).approved ? 'fas fa-calendar-check' : 'far fa-calendar-xmark';
  }
  href() {
    return '/events/' + ((this.attrs.notification.content() || {}).eventId || '');
  }
  content() {
    return (this.attrs.notification.content() || {}).approved ? 'Your event was approved and is live' : 'Your event was not approved';
  }
  excerpt() {
    return (this.attrs.notification.content() || {}).title || '';
  }
}
export default function registerEventNotifications() {
  app.notificationComponents.vouchaEventPending = EventPendingNotification;
  app.notificationComponents.vouchaEventReviewed = EventReviewedNotification;
  // Settings > Notifications (the settings page loads on demand in Flarum 2, so hook it by its path)
  extend('flarum/forum/components/NotificationGrid', 'notificationTypes', function (items) {
    items.add('vouchaEventReviewed', {
      name: 'vouchaEventReviewed',
      icon: 'far fa-calendar-check',
      label: 'Someone approves or turns down my event'
    });
    const user = app.session.user;
    if (user && user.isAdmin && user.isAdmin()) {
      items.add('vouchaEventPending', {
        name: 'vouchaEventPending',
        icon: 'far fa-calendar',
        label: 'A member posts an event that needs approval'
      });
    }
  });
}
flarum.reg.add('voucha-community', 'forum/events/notifications', registerEventNotifications);